import React, { useEffect, useState, useRef } from "react";
import moment from "moment";
import { Button, ButtonGroup, Alert, Spinner, Form, InputGroup } from "react-bootstrap";
import { Envelope, Search } from "react-bootstrap-icons"

import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community'; 

import { getMails } from "../../_helpers/api";

import MailViewer from "../MailViewer";

// Register all Community features
ModuleRegistry.registerModules([AllCommunityModule]);

// number of days
const numberDays = 7;

const Mails = (props) => {

  const gridRef = useRef();
  const [ loading, setLoading ] = useState(true);
  const [ mails, setMails ] = useState([]);
  const [ displayedRowCount, setDisplayedRowCount ] = useState(0);

  const [ filter ] = useState({receivedDateTime: { $gte: moment().subtract(numberDays, "day").toDate() }});
  const [ searchId, setSearchId ] = useState("");
  
  const [ selectedMail, setSelectedMail ] = useState("");
  const [ showMailViewer, setShowMailViewer ] = useState(false);

  const recipientsToString = (props) => {
    return props.value?.map(r => r.emailAddress.address).join(", ");
  }

  const renderButtons = (props) => {
    const mailId = props.data._id;
    return (
      <ButtonGroup>
        <Button variant="link" size="sm" onClick={() => { setSelectedMail(mailId); setShowMailViewer(true)}}><Envelope /></Button>
      </ButtonGroup>
    );
  }

  // Column Definitions: Defines the columns to be displayed.
  const [colDefs] = useState([
      { field: "receivedDateTime", sortable: true, flex: 2, //filter: 'agDateColumnFilter',
        valueFormatter: (params) => moment(params.value).format("DD.MM.YYYY HH:mm:ss")
      },      
      { field: "subject", sortable: true, filter: true, flex: 4},
      { field: "from", valueFormatter: (params) => params.value.emailAddress?.address, sortable: true, filter: true, flex: 3},
      { field: "toRecipients", valueFormatter: recipientsToString, sortable: true, filter: true, flex: 3},
      { field: "status", sortable: true, filter: true, flex: 1},
      {field: "", sortable: false, filter: false, flex: 1, cellRenderer: renderButtons}
  ]);

  const fetchMails = async () => {
    setLoading(true);
    let mails = await getMails(filter);
    setMails(mails);
    setLoading(false);
  };

  useEffect(() => {
    fetchMails();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filteredMails = searchId 
    ? mails.filter(mail => mail._id.toLowerCase().includes(searchId.toLowerCase()))
    : mails;

  const onFilterChanged = () => {
    if (gridRef.current?.api) {
      setDisplayedRowCount(gridRef.current.api.getDisplayedRowCount());
    }
  };

  const onGridReady = () => {
    if (gridRef.current?.api) {
      setDisplayedRowCount(gridRef.current.api.getDisplayedRowCount());
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1, overflow: 'hidden' }}>
      <Alert variant="info">Es werden nur Mails der letzten {numberDays} Tage angezeigt. Die Mails werden jeweils zur vollen Stunde abgerufen.</Alert>
      {loading ? <Spinner animation="border" /> : (
        <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1, overflow: 'hidden' }}>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <InputGroup style={{ maxWidth: "400px" }}>
              <InputGroup.Text>
                <Search />
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="Search by Mail ID..."
                value={searchId}
                onChange={(e) => setSearchId(e.target.value)}
              />
            </InputGroup>
            <div className="text-muted">
              {displayedRowCount} {displayedRowCount === 1 ? 'mail' : 'mails'}
            </div>
          </div>
          <div
            style={{ flex: 1, minHeight: 0, width: "100%" }}
          >
              <AgGridReact
                      ref={gridRef}
                      rowData={filteredMails}
                      columnDefs={colDefs}
                      onFilterChanged={onFilterChanged}
                      onGridReady={onGridReady}
              />
              <MailViewer show={showMailViewer} handleClose={() => setShowMailViewer(!showMailViewer)} mailId={selectedMail}/>
          </div>
        </div>
      )}
    </div>
  );
}

export default Mails;